const ru = {
  // Navigation
  nav_home: "Дом",
  nav_explore: "Исследовать",
  nav_workspace: "Рабочая область",
  ws_videos: "видео",
  ws_untitled: "Видео без названия",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Видео не удалось",
  ws_failed_refunded: "Ваш кредит был возвращен",
  ws_failed_dismiss: "Увольнять",
  ws_failed_retry: "Попробуйте еще раз",
  ws_failed_retrying: "Начало…",
  ws_failed_banner_one: "Видео не удалось создать",
  ws_failed_banner_many: "{n} видео не удалось",
  ws_failed_banner_body: "Ничего не было списано — кредит вернулся на ваш счет. Попробуйте еще раз или выберите другую тему.",
  ws_empty_title: "Здесь пока ничего.",
  ws_empty_body: "Здесь будут появляться все созданные вами видео, сначала самые новые.",
  ws_generate: "Генерировать",
  ws_composer_placeholder: "Опишите урок\u2026",
  ws_placeholder_hw: "Назовите задание… (необязательно)",
  ws_placeholder_lecture: "Назовите лекцию… (необязательно)",
  ws_placeholder_self_study: "Что вы хотите изучить?",
  nav_search: "Поиск видео...",
  nav_search_yours: "Найдите свои видео...",
  nav_notifications: "Уведомления",
  nav_mark_all_read: "Отметить все прочитанными",
  nav_no_notifications: "Уведомлений пока нет",
  nav_no_notifications_sub: "Мы сообщим вам, когда ваши видео будут готовы",
  nav_upgrade: "Обновление",
  nav_billing: "Биллинг",
  nav_settings: "Настройки",
  nav_contact: "Связаться с нами",
  nav_api: "API",
  nav_sign_out: "выход",
  nav_just_now: "Прямо сейчас",
  nav_minutes_ago: "{n} м назад",
  nav_hours_ago: "{n} ч назад",
  nav_days_ago: "{n} дня назад",
  nav_used_this_month: "{used} из {cap} использовано в этом месяце",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "Использовано на этой неделе: {used} из {limit}",
  nav_free_daily: "4 бесплатных видео в неделю",
  // Settings
  settings_title: "Настройки",
  settings_profile: "Профиль",
  settings_change_avatar: "Сменить аватар",
  settings_cancel: "Отмена",
  settings_choose_wizard: "Выберите своего мастера",
  settings_display_name: "Отображаемое имя",
  settings_your_name: "Ваше имя",
  settings_save: "Сохранять",
  settings_saving: "Сохранение...",
  settings_saved: "Сохранено",
  settings_save_failed: "Не удалось сохранить",
  settings_email: "Электронная почта",
  settings_notifications: "Уведомления",
  settings_email_notif: "Уведомления по электронной почте",
  settings_email_notif_desc: "Получайте обновления и объявления по электронной почте",
  settings_language: "Язык",
  settings_language_desc: "Выберите язык приложения и видео-репортажа.",
  settings_data_title: "Ваши данные",
  settings_data_desc: "Загрузите копию личных данных, связанных с вашей учетной записью, включая ваш профиль, видео, курсы, сеансы и сообщения поддержки. Внутренние системные журналы и производные данные обработки не включены.",
  settings_data_download: "Загрузите мои данные",
  settings_data_exporting: "Подготовка…",
  settings_danger: "Опасная зона",
  settings_delete_account: "Удалить аккаунт",
  settings_delete_desc: "Удалите навсегда свою учетную запись и все связанные с ней данные. Это действие невозможно отменить.",
  settings_delete_confirm: "Это приведет к безвозвратному удалению вашей учетной записи и всех ваших данных. Введите {keyword} для подтверждения.",
  settings_delete_placeholder: "Введите «УДАЛИТЬ» для подтверждения.",
  settings_permanently_delete: "Удалить навсегда",
  settings_deleting: "Удаление...",
  explore_watch_now: "Смотреть сейчас",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Нет предварительного просмотра",
  explore_no_videos: "Пока нет доступных видео. Возвращайтесь скорее!",
  explore_featured_courses: "Рекомендуемые курсы",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Вернуться к исследованию",
  course_not_found: "Этот курс недоступен.",
  // Home Page
  home_hero: "Узнать что-нибудь,",
  home_hero_accent: "визуально",
  home_placeholder: "Что вы хотите узнать или решить?",
  home_extracting: "Извлечение вопросов...",
  home_videos_generated: "Будет создано {n, plural, one {# видео} few {# видео} many {# видео} other {# видео}}",
  home_credits: "{n, plural, one {# кредит} few {# кредита} many {# кредитов} other {# кредита}}",
  home_remaining: "осталось в этом месяце",
  home_enter_prompt: "Пожалуйста, введите то, что вы хотите узнать или решить",
  home_popular: "Популярные уроки",
  home_from_community: "От сообщества",
  home_community_sub: "Посмотрите, что создают студенты",
  home_tips_label: "От волшебника-волшебника",
  home_tips_title: "Советы и рекомендации",
  home_tip1_title: "Получите конкретику",
  home_tip1_desc: "Не вводите всю тему. Выберите одну идею, одну концепцию, один вопрос.",
  home_tip1_example: "Как происходит репликация ДНК в эукариотических клетках",
  home_tip2_title: "Скажи, для кого это",
  home_tip2_desc: "Объяснение в средней школе совершенно отличается от лекции в колледже.",
  home_tip2_example: "Объясните производные тому, кто только что выучил алгебру.",
  home_tip3_title: "Скажи Маги, что ты хочешь",
  home_tip3_desc: "Примеры, пошаговые инструкции и реальные применения — просто скажите это, и Magi последует за вами.",
  home_tip3_example: "Круговорот воды с реальными примерами и кратким изложением",
  home_tip_try: "Попробуйте что-нибудь вроде",
  home_proven_social: "Следуйте за нами в Instagram",
  home_ig_desc_1: "Над",
  home_ig_followers: "55 000 подписчиков",
  home_ig_desc_2: "смотрите наши видеоролики по математике и естественным наукам в Instagram каждый день. Эти катушки сделаны на том же двигателе, который вы используете здесь.",
  home_view_profile: "Посмотреть профиль",
  home_subscribe_now: "Подпишитесь сейчас",
  home_sub_monthly: "Ежемесячно",
  home_sub_yearly: "Ежегодно",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Сэкономьте {pct}%",
  home_sub_per_month: "/ месяц",
  home_sub_billed_monthly: "выставляется счет на сумму ${amount} каждый месяц",
  home_sub_processing: "Обработка...",
  home_sub_no_commitment: "Никаких обязательств. Отменить в любое время.",
  home_sub_secured: "Защищено Stripe",
  home_sub_headline: "Разблокируйте больше с {plan}",
  home_sub_due_now: "Срок оплаты сейчас",
  home_sub_trial_label: "Полный доступ на {days}-день",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Сегодня с вас будет списана сумма в размере ${amount} за {n} видео в этом месяце. {date} он продлевается по цене ${amount} в месяц, если вы сначала не отмените подписку — отмените ее в любой момент в разделе \"Выставление счетов\".",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Сегодня с вас будет снята плата в размере ${trial} за {days} дн. полного доступа, ограниченного числом видео: {n}. Пробная версия не продлевается по цене ${trial} — с {date} она автоматически становится {planName} по цене ${plan} в месяц ({full} видео), и после этого каждый месяц взимается плата в размере ${plan}, пока вы не отмените подписку. Отмените в любое время из Billing.",
  home_sub_card: "Кредитная или дебетовая карта",
  home_sub_billed_once_yearly: "выставляется счет на сумму ${amount} один раз в год",
  home_sub_billed_trial: "выставлен счет на сумму ${amount} за {days} дн., затем продлевается на сумму ${renews} каждый месяц.",
  home_sub_switch_plan: "Вместо этого ищете {plan}?",
  home_sub_replaces_plan: "Заменяет ваш план {plan}. Дата выставления счета остается прежней: при переходе вверх взимается разница, а при переходе вниз начинается при следующем продлении.",
  home_sub_change_now: "Вы перешли на {plan} — списано {amount} за разницу.",
  home_sub_change_later: "Вы перейдёте на {plan} {date}. Сегодня ничего не списано.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} видео в месяц",
  // Pricing Page
  pricing_title: "Обновите свой план",
  pricing_monthly: "Ежемесячно",
  pricing_yearly: "Ежегодно",
  pricing_save: "Сэкономьте 17%",
  pricing_best_value: "Лучшее соотношение цены и качества",
  pricing_your_plan: "Ваш текущий план",
  pricing_get_started: "Начать",
  pricing_processing: "Обработка...",
  pricing_per_month: "/месяц",
  pricing_billed_yearly: "Выставлен счет ${amount}/год",
  pricing_videos_month: "{n, plural, one {# видео} few {# видео} many {# видео} other {# видео}}/месяц",
  pricing_manage_cancel: "Управлять или отменить",
  pricing_manage_unavailable: "Не нашли подписку для управления. Напишите нам, и мы всё уладим.",
  pricing_opening: "Открытие...",
  billing_autorenew_monthly: "Продлевается автоматически за ${amount}/месяц, пока вы не отмените подписку.",
  billing_autorenew_yearly: "Продлевается автоматически по цене ${amount}/год, пока вы не отмените подписку.",
  billing_autorenews_on: "Автоматическое продление {date} · отмена в любое время",
  pricing_secured: "Защищено Stripe",
  pricing_login_required: "Пожалуйста, войдите, чтобы подписаться",
  pricing_auth_error: "Ошибка аутентификации пользователя. Пожалуйста, попробуйте выйти и снова войти.",
  pricing_feature_pdf: "Извлечение PDF и изображений",
  pricing_feature_quality: "Модель более высокого качества",
  pricing_feature_speed: "Более быстрое время генерации",
  pricing_feature_study: "Учебные занятия",
  pricing_free_hint: "Сейчас на бесплатном плане",
  // Billing Page
  billing_title: "Биллинг",
  billing_current_plan: "Текущий план",
  billing_payment_failed_title: "Ваш план приостановлен",
  billing_payment_failed_body: "Нам не удалось получить {amount}, поэтому ваш план приостановлен. Обновите свою карту, чтобы запустить ее снова. Мы также продолжим повторные попытки.",
  billing_payment_failed_cta: "Исправить оплату",
  billing_change_plan: "Изменить план",
  billing_invoices: "Счета-фактуры",
  billing_loading: "Загрузка счетов...",
  billing_no_invoices: "Счетов пока нет",
  billing_date: "Дата",
  billing_amount: "Количество",
  billing_status: "Статус",
  billing_invoice: "Счет",
  billing_view: "Вид",
  // Contact Page
  contact_title: "Связаться с нами",
  contact_placeholder: "Как мы можем помочь?",
  contact_sent_desc: "Мы свяжемся с вами как можно скорее.",
  contact_signin: "Пожалуйста, войдите в систему, чтобы связаться со службой поддержки.",
  // Generation Queue
  queue_title: "Очередь",
  queue_active: "{n} активен",
  queue_generating: "{n} генерирует",
  queue_ready: "Готов смотреть",
  queue_in_queue: "Ожидание в очереди...",
  queue_almost_ready: "Почти готово...",
  queue_seconds_left: "осталось {n}",
  queue_minutes_left: "осталось {m} м {s} сек.",
  queue_watch_now: "Смотреть сейчас",
  queue_waiting: "Ожидание в очереди...",
  queue_empty: "Нет видео в очереди",
  queue_empty_sub: "Создайте видео, чтобы увидеть его здесь",
  queue_clear: "Очистить все",
  queue_total: "Всего {n}",
  queue_first_time: "Ваше видео создается",
  queue_first_time_sub: "Обычно ~2 мин. Когда блюдо будет готово, вы услышите звуковой сигнал.",
  // Session Expired
  session_expired: "Срок действия сессии истек",
  session_expired_desc: "Срок действия вашей сессии истек по соображениям безопасности. Пожалуйста, войдите еще раз, чтобы продолжить.",
  // Cookie Banner
  cookie_text: "Мы используем файлы cookie для анализа трафика сайта и улучшения вашего опыта. По умолчанию устанавливаются только необходимые файлы cookie.",
  cookie_learn_more: "Узнать больше",
  cookie_accept: "Принять все",
  cookie_reject: "Отклонить несущественное",
  // Create Project Modal
  create_new_project: "Новый проект",
  create_extracting: "Извлечение...",
  create_select_problems: "Выберите проблемы",
  create_select_topics: "Выберите темы",
  create_new_video: "Новое видео",
  create_new_hw: "Новый проект домашнего задания",
  create_new_lecture: "Новый лекционный проект",
  create_new_self_study: "Новый проект",
  create_video: "Видео",
  create_homework: "Домашнее задание",
  create_lecture: "Лекция",
  create_self_study: "Проект",
  create_video_sub: "Создать видео",
  create_hw_sub: "Загрузить домашнее задание",
  create_lecture_sub: "Загрузить слайды",
  create_self_study_sub: "Выбирайте темы",
  create_video_prompt: "Что должно объяснять видео?",
  create_project_title: "Название проекта",
  create_video_hint: "Он будет использоваться как заголовок и подсказка для вашего видео.",
  create_drop_hw: "Скиньте сюда домашнее задание",
  create_drop_lecture: "Скиньте сюда слайды своих лекций",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Перетащите, чтобы начать проект",
  create_reading_hw: "Чтение домашнего задания",
  create_reading_lecture: "Читаю вашу лекцию",
  create_finding_problems: "Нахождение и устранение проблем...",
  create_finding_topics: "Извлечение тем...",
  create_add_video: "Добавить еще видео",
  create_add_more_files: "Добавить больше файлов",
  create_starting: "Начало поколения...",
  create_generate_video: "Создать видео7 1 кредит",
  create_generate_n: "Создать {n, plural, one {# видео} few {# видео} many {# видео} other {# видео}} \u00B7 {n, plural, one {# кредит} few {# кредита} many {# кредитов} other {# кредита}}",
  create_create_project: "Создать проект \u00B7 {n, plural, one {# кредит} few {# кредита} many {# кредитов} other {# кредита}}",
  create_no_problems: "Не смог найти никаких проблем. Попробуйте более четкое фото или другую страницу.",
  create_no_topics: "Не удалось найти ни одной темы. Попробуйте более четкое фото или другой файл.",
  create_error: "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
  create_extract_daily_limit: "Это все документы на сегодня. Подробнее завтра.",
  create_video_topic_placeholder: "Тема видео {n}, например. «Собственные значения и собственные векторы»",
  video_share: "Делиться",
  // and made the two indistinguishable.
  video_followup_placeholder: "Создать последующее видео...",
  video_chip_simpler: "Объясните проще",
  video_chip_harder: "Более сложный пример",
  video_chip_real_world: "Реальное использование",
  // spends a credit generating a new one.
  video_ask_title: "Спросите об этом видео",
  video_ask_cta: "Поговорите об этом",
  video_ask_placeholder: "Задайте вопрос...",
  video_ask_thinking: "Думая...",
  video_ask_close: "Закрывать",
  video_ask_chip_explain: "Объясните эту часть",
  video_ask_chip_example: "Приведите пример",
  video_ask_chip_why: "Почему это работает?",
  video_ask_limit_reached: "Вы достигли сегодняшнего лимита вопросов. Завтра он обнуляется.",
  video_up_next: "Далее",
  video_no_suggested: "Рекомендованных видео пока нет.",
  video_untitled: "Видео без названия",
  video_created_recently: "Создано недавно",
  video_just_now: "Прямо сейчас",
  video_minutes_ago: "{n, plural, one {# минуту} few {# минуты} many {# минут} other {# минуты}} назад",
  video_hours_ago: "{n, plural, one {# час} few {# часа} many {# часов} other {# часа}} назад",
  video_days_ago: "{n, plural, one {# день} few {# дня} many {# дней} other {# дня}} назад",
  video_weeks_ago: "{n, plural, one {# неделю} few {# недели} many {# недель} other {# недели}} назад",
  video_months_ago: "{n, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}} назад",
  video_years_ago: "{n, plural, one {# год} few {# года} many {# лет} other {# года}} назад",
  video_unknown_date: "Неизвестная дата",
  video_download_error: "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
  // Search Results
  search_no_results: "Результаты не найдены",
  search_no_results_for: "По запросу \"{query}\" результатов не найдено.",
  search_all_videos: "Искать все видео",
  search_enter_term: "Введите поисковый запрос, чтобы найти видео",
  search_retry: "Повторить поиск",
  auth_continue_google: "Продолжить с Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Начни мой доступ прямо сейчас. Я понимаю, что это означает, что я отказываюсь от права на вывод средств в течение {days} дней и получения возмещения.",
  home_sub_waiver_required: "Пожалуйста, подтвердите это, чтобы продолжить.",
  home_sub_agree_prefix: "Продолжая, вы соглашаетесь с нашими",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Чтобы использовать Magi, вам должно быть {age} или больше.",
  auth_agree_prefix: "Выполняя вход, вы соглашаетесь с нашими",
  auth_terms: "Условия использования",
  auth_and: "и",
  auth_privacy: "политика конфиденциальности",
  auth_email_optin: "Присылайте мне советы и обновления",
  // Auth modal (Google + email/password)
  auth_signin_title: "Войдите в Маги",
  auth_signin_desc: "Продолжайте с того места, где вы остановились.",
  auth_signup_title: "Создайте свою учетную запись",
  auth_signup_desc: "Начало бесплатное, карта не нужна.",
  auth_or: "или",
  auth_continue_email: "Продолжить по электронной почте",
  auth_signing_in: "Вход в систему…",
  auth_working: "Еще секундочку…",
  auth_email_placeholder: "Адрес электронной почты",
  auth_password_placeholder: "Пароль",
  auth_signin_submit: "Войти",
  auth_signup_submit: "Зарегистрироваться",
  auth_no_account: "Впервые здесь?",
  auth_signup_link: "Завести аккаунт",
  auth_have_account: "У вас уже есть аккаунт?",
  auth_signin_link: "Войти",
  auth_forgot_password: "Забыли пароль?",
  auth_reset_title: "Сбросить пароль",
  auth_reset_desc: "Мы вышлем вам ссылку для установки новой.",
  auth_reset_submit: "Отправить ссылку для сброса",
  auth_reset_sent: "Проверьте свою электронную почту на наличие ссылки для сброса.",
  auth_back_to_signin: "Вернуться для входа в систему",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Подтвердите свой адрес электронной почты, чтобы продолжить",
  verify_wall_desc: "Мы отправили ссылку для подтверждения на адрес {email}. Нажмите на нее, а затем вернитесь сюда.",
  verify_wall_check: "Я это подтвердил",
  verify_wall_checking: "Проверка...",
  verify_wall_still_unverified: "Еще не подтверждено. Нажмите ссылку в письме и повторите попытку.",
  verify_wall_resend: "Отправьте ссылку еще раз",
  verify_wall_resent: "Отправил. Проверьте свой почтовый ящик и папку со спамом.",
  verify_wall_wrong_account: "Неправильный аккаунт? выход",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Подтверждение вашей электронной почты",
  verify_action_working_desc: "Один момент.",
  verify_action_done_title: "Все готово",
  verify_action_done_desc: "Ваш адрес электронной почты подтвержден. Добро пожаловать в Magi.",
  verify_action_done_cta: "Начать обучение",
  verify_action_failed_title: "Эта ссылка не сработала",
  verify_action_failed_desc: "Возможно, он уже использовался или срок его действия истек. Вернитесь и отправьте себе новый.",
  verify_action_failed_cta: "Назад в Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Войдите, чтобы посмотреть",
  auth_watch_desc: "Создайте бесплатную учетную запись для воспроизведения этого видео.",
  auth_watch_ready_title: "Ваше видео готово",
  auth_watch_ready_desc: "Войдите, чтобы посмотреть его — он будет сохранен в вашей учетной записи.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Войдите, чтобы скачать",
  auth_download_desc: "Создайте бесплатную учетную запись, чтобы сохранить это видео.",
  auth_ask_title: "Войдите, чтобы задать вопрос",
  auth_ask_desc: "Создайте бесплатную учетную запись, чтобы задать вопрос об этом видео.",
  auth_browse_title: "Войдите, чтобы просмотреть",
  auth_browse_desc: "Создайте бесплатную учетную запись, чтобы изучить каждый урок.",
  auth_workspace_title: "Войдите, чтобы увидеть свою работу",
  auth_workspace_desc: "Ваши уроки и проекты живут в вашем аккаунте.",
  auth_generate_title: "Войдите, чтобы продолжить творить",
  auth_generate_desc: "Бесплатные аккаунты получают видео каждый день.",
  video_restricted: "Это видео пока недоступно.",
  // Share sheet
  share_title: "Поделитесь этим видео",
  share_desc_mobile: "Опубликуйте его в своей истории, отправьте другу или скопируйте ссылку.",
  share_desc_desktop: "Скопируйте ссылку или загрузите видео для публикации со своего телефона.",
  share_to_apps: "Поделиться в Instagram и не только",
  share_copy_link: "Копировать ссылку",
  share_copied: "Ссылка скопирована",
  share_download: "Скачать видео",
  share_preparing: "Готовим…",
  share_watermark_note: "Общие видео включают сайт magiacademy.com.",
  // Welcome Modal (post-signup)
  welcome_title: "Добро пожаловать в Маги",
  welcome_subtitle: "Для начала у вас есть 4 бесплатных видео.",
  welcome_optin_reward: "+1 бесплатное видео",
  welcome_continue: "Продолжать",
  age_gate_continue: "Продолжать",
  age_gate_saving: "Сохранение...",
  // Landing Page
  landing_hero: "Введите тему.",
  landing_hero2: "Получите видео урок.",
  landing_subtitle: "Magi за считанные минуты превращает любой предмет в красивое анимированное видео с рассказом. Никаких съемок, никакого монтажа, никакой экспертизы не требуется.",
  landing_signup_google: "Зарегистрируйтесь через Google",
  landing_signing_in: "Вход в систему...",
  landing_chat_bubble: "Как GPS использует теорию относительности?",
  landing_stats_title: "Нам доверяют учащиеся по всему миру",
  landing_stat_videos: "3000+",
  landing_stat_videos_desc: "Созданные видео",
  landing_stat_languages_desc: "Языки",
  landing_stat_speed: "~1 мин.",
  landing_stat_speed_desc: "Время генерации",
  landing_feature_lecture_title: "Оставляйте конспекты лекций, получайте видео",
  landing_feature_lecture_desc: "Загрузите свои слайды или заметки. Маги извлекает каждую тему и создает для каждой видеообъяснение.",
  landing_feature_hw_title: "Застряли на домашнем задании? Загрузите его.",
  landing_feature_hw_desc: "Отправьте набор задач, и Magi выделит каждую проблему, а затем покажет вам решение в пошаговом видео.",
  landing_feature_chat_title: "Задавайте вопросы во время просмотра",
  landing_feature_chat_desc: "В каждом видео есть наставник по искусственному интеллекту, с которым вы можете общаться. Задавайте дополнительные вопросы, получайте более глубокие объяснения или запросите новое видео по определенной части, которую вы хотите лучше понять.",
  landing_feature_lang_title: "Учитесь на своем языке",
  landing_feature_lang_desc: "Magi создает видео на английском, испанском, хинди, китайском, японском и других языках. Введите свою тему на любом языке и получите полностью рассказанный урок на этом языке.",
  landing_cta_title: "Начните обучение за считанные секунды",
  landing_cta_google: "Продолжить с Google",
  // Onboarding Bubbles
  onboarding_step1: "Это не чат-бот — введите тему, и я сгенерирую для вас полный видеоурок!",
  onboarding_step2: "Или киньте PDF или фото \u2014 Я превращу каждую проблему в пошаговое видео решение",
  onboarding_step3: "Нажмите «Вперед», и ваше видео появится в очереди. Вы можете продолжать просмотр во время рендеринга!",
  onboarding_generating: "Это ваш урок рисуется пару минут. Продолжайте просмотр, если хотите; он приземлится прямо здесь, когда будет готов.",
  onboarding_skip: "Пропускать",
  onboarding_next: "Следующий",
  onboarding_done: "Понятно!",
  // Generating Cards Row
  generating_label: "Создание",
  // Lecture Session (Self Study)
  lecture_loading: "Загрузка...",
  lecture_fallback_title: "Лекция",
  lecture_building: "Строительное видео...",
  lecture_building_time: "Обычно это занимает 2-4 минуты",
  lecture_failed: "Не удалось создать видео.",
  lecture_no_video: "Видео пока нет",
  lecture_followup: "Следовать за",
  lecture_now_playing: "Сейчас играю",
  lecture_tab_videos: "Видео",
  lecture_tab_chat: "Чат",
  lecture_chat_empty: "Спросите что-нибудь по этой теме",
  lecture_chat_chip1: "Объясните просто",
  lecture_chat_chip2: "Приведите пример",
  lecture_chat_chip3: "Почему это полезно?",
  lecture_chat_placeholder: "Спросите на эту тему...",
  lecture_followup_placeholder: "Добавьте следующее видео...",
  lecture_chat_error: "Извините, я не смог это обработать. Попробуйте еще раз.",
  lecture_chat_generic_error: "Что-то пошло не так. Попробуйте еще раз.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Домашнее задание PDF",
  home_sc_hw_desc: "Загрузите набор задач и получите проработанное видео по каждому вопросу.",
  home_sc_lecture_title: "Лекция PDF",
  home_sc_lecture_desc: "Превратите слайды или заметки в серию уроков",
  home_sc_course_title: "Создать курс",
  home_sc_course_desc: "Планируйте последовательность уроков по одной теме",
  // Misc
  generic_error: "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
  loading: "Загрузка...",
};

export default ru;
